<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Product Category Detail</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button
            @click="showAddForm = true; form = { name: '', product_category_id: null }"
            class="btn mb-4 md:mb-0 mr-1"
            icon="add"
            v-if="hasAccess('create')"
          >Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
            v-if="hasAccess('delete')"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate" v-if="hasAccess('create')">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()" v-if="hasAccess('create')">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="productcategorydetails"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <vs-input label="Name" v-model="filter.name" class="mb-2 w-full" />
          <label class="vs-input--label">Product Category</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.product_category_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, product_category)"
          >
              <vs-select-item v-for="(item, index) in product_category.data" :key="index" :value="item.id" :text="item.name"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.name" class="mb-2 w-full" label="Name" />
          <label class="vs-input--label">Product Category</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.product_category_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, product_category)"
          >
              <vs-select-item v-for="(item, index) in product_category.data" :key="index" :value="item.id" :text="item.name"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.name" class="mb-2 w-full" label="Name" :disabled="!editMode"/>
          <label class="vs-input--label">Product Category</label>
          <vs-select
              class="selectExample mb-2"
              v-model="form.product_category_id"
              width="100%"
              autocomplete
              :disabled="!editMode"
              @input-change="searchDropdown($event, product_category)"
          >
              <vs-select-item v-for="(item, index) in product_category.data" :key="index" :value="item.id" :text="item.name"/>
          </vs-select>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" class="mt-2" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      popupType: '',
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      columnDefs: null,
      editMode: false,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      showFilter: false,
      filter: {
        product_category_id: null,
        name: ""
      },
      showAddForm: false,
      showViewForm: false,
      form: {
        name: '',
        product_category_id: null
      },
      productcategorydetails: [],
      productcategories: [],

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,

      product_category: {
        data: [],
        loading: false,
        endpoint: 'master/productcategories',
        objectKey: 'name'
      },
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },

    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    fetchProductCategory(search, loading) {
      loading(true)
      const data = {
          name: search
      }
      this.$http.post('master/productcategories', data)
      .then(res => {
        res.data.data.map(item => {
          const index = this.product_category.findIndex(a => a.value == item.id)
          if(index === -1) {
            this.product_category.push({
              value: item.id,
              label: item.name
            })
          }
        })
        loading(false)
      })
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this category?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete(
          "master/productcategoriesdetail/" + this.selectedId + "/destroy"
        )
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Category deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected category was successfully deleted"
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: "Error.",
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post(
          "master/productcategoriesdetail?page=" + this.currentPage,
          this.filter
        )
        .then(resp => {
          this.productcategorydetails = resp.data.data;
          this.totalPage = resp.data.last_page;
          this.currentPage = this.currentPage;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.isLoading = false;
        })
        .catch(resp => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
          return;
        });
    },
    viewData() {
      this.isLoading = true;
      this.$http
        .get("master/productcategoriesdetail/" + this.selectedId)
        .then(res => {
          this.editMode = false
          this.form = res.data;
          this.showViewForm = true;
          if(this.product_category.data.findIndex(a => a.id == res.data.product_category_id) === -1) {
            this.product_category.push({
              id: res.data.product_category_id,
              name: res.data.product_category
            })
          }
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/productcategoriesdetail/" + this.selectedId + "/update", this.form)
        .then(res => {
          this.isLoading = false;
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/productcategoriesdetail/store", this.form)
        .then(res => {
          this.isLoading = false;
          this.showAddForm = false;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))
    },
    filterData() {
      this.currentPage = 1;
      this.showFilter = false;
      this.fetchData();
    },
    filterActive() {
      this.showFilter = !this.showFilter;
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/productcategoriesdetail/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "product-category-detail-upload-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/productcategoriesdetail/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload Data Product Category Detail Successfully"
          });
        })
        .catch(error => {
          this.isLoading = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            color: "danger",
            title: "Upload Failed",
            text: message
          });
        });
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post(
          "master/productcategoriesdetail/report/exportexcel",
          this.filter,
          {
            responseType: "blob"
          }
        )
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "product-category-detail-list-export.xlsx");
        });
    },
    showPopup(data) {
      if(data.rowData.length < 1) {
        this.searchPopup(data)
      }
      else {
        data.show = true
      }
    },
    searchPopup(data) {
      this.isLoading = true
      this.$http.post(data.endpoint, {dropdown_filter: data.filter})
      .then(res => {
        data.show = true
        data.rowData = res.data.data
        this.isLoading = false
      })
    },
    setData(data, fieldName) {
      let selectedRows = data.gridOptions.api.getSelectedRows()
      let selectedRowsString = null
      selectedRows.forEach(function(selectedRow, index) {
          if (index !== 0) {
              selectedRowsString += ", "
          }
          selectedRowsString = selectedRow
      });

      if(this.popupType == 'form') {
        this.$set(this.form, 'product_category', selectedRowsString[fieldName])
      }
      else {
          this.$set(this.filter, 'product_category', selectedRowsString[fieldName])
      }
      data.show = false
    },
    fetchDropdown() {
      this.isLoading = true
      return Promise.all([
        this.$http.post(
          "master/productcategories",
        ),
      ]).then(
        this.$http.spread((productcategories) => {
          productcategories.data.data.map(product_category => {
            if(this.product_category.data.findIndex(a => a.id == product_category.id) === -1) {
              this.product_category.data.push(product_category)
            }
          })
        })
      )
    },
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      // {
      //   headerName: "Prd-Cat Detail ID",
      //   field: "id",
      //   width: 200,
      //   filter: true
      // },
      {
        headerName: "Category",
        field: "product_category_name",
        width: 120,

      },
      {
        headerName: "Name",
        field: "name",
        width: 120,
      },
    ];

    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>